/**
 * Values of `_class` properties for all items in @see Design except for @see DesignObject.
 *
 * @note See @see ObjectClass for classes used on @see DesignObject.
 * @note See @see NodeClass for classes used on @see DesignModuleNode.
 */
export enum DesignClass {
  condition = 'ConditionNodeModel',
  intent = 'IntentDataModel',
  link = 'BaseLinkModel',
  module = 'ModuleNodeModel',
  variable = 'VariableDataModel'
}
